import React from "react";
import headerImage from "../components/intro-bg.jpg"; // adjust path accordingly
import "./Header.css";

export const Header = (props) => {
  return (
    <header
      id="header"
      className="header"
      style={{
        backgroundImage: `url(${props.data?.backgroundImage || headerImage})`,
        boxShadow: "0 10px 20px rgba(0, 0, 0, 0.5)",
      }}
    >
      <div className="overlay">
        <div className="header-content fade-in">
          <h1>{props.data ? props.data.title : "Loading..."}</h1>
          <p>{props.data ? props.data.paragraph : "Loading..."}</p>

          <a href="#about" className="btn btn-custom btn-lg">
            Conócenos
          </a>
        </div>
      </div>
    </header>
  );
};
